import React from 'react';
import Reveal from './atoms/reveal';

const CARRIER = [
    {
        period: 'April 2020 - Now',
        name: 'シナジーマーケティング株式会社',
        href: 'https://www.synergy-marketing.co.jp',
        description: 'CRM プラットフォーム Synergy! の顧客管理などに使われるデータベース機能のバックエンドエンジニア.',
    },
    {
        period: 'March 2019 - July 2019',
        name: '株式会社ネットオン',
        href: 'https://neton.co.jp',
        description: '長期インターンに参加させていただきました。PHPを使い採用係長の開発や開発環境の検証などをしました。',
    },
    {
        period: 'April 2016 - March 2020',
        name: '甲南大知能学情報学部',
        href: 'https://www.konan-u.ac.jp/faculty/ii/ii/',
        description: '大学時代の専門はソフトウェア工学で、リバースエンジニアリングやフォワードエンジニアリングについて研究。卒業論文ではゼミ活動で作成したアプリのバックエンドをnode.jsで作成し直し生産性などを比較を行った。',
    },
];

function Carrier() {
    return (
        <section id="carrier" className="parallax text-center py-10" data-stellar-background-ratio="0.5">
            <div className="flex items-center justify-center py-5">
                <div className="container relative z-30">
                    <Reveal className="section-heading text-center">
                        <h2 className="text-4xl text-center font-semibold pb-6">Carrier</h2>
                    </Reveal>

                    <div className="container">
                        <div className="relative mx-auto mt-12 flex w-full flex-col lg:w-2/3 px-10">
                            <span className="left-2/5 absolute inset-y-0 ml-10 hidden w-0.5 bg-black md:block"></span>

                            {CARRIER.map((entry, i) => (
                                <Reveal
                                    key={entry.name}
                                    variant="left"
                                    delay={i * 150}
                                    className="mt-8 flex flex-col text-center md:flex-row md:text-left"
                                >
                                    <div className="md:w-2/5">
                                        <div className="flex justify-center md:justify-start">
                                            <span className="shrink-0">{entry.period}</span>
                                            <div className="relative ml-3 hidden w-full md:block">
                                                <span className="absolute inset-x-0 top-1/2 h-0.5 -translate-y-1/2 transform bg-black"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:w-3/5">
                                        <div className="relative flex md:pl-18">
                                            <span className="absolute left-8 top-1 hidden h-4 w-4 rounded-full border-2 border-grey-40 bg-white md:block"></span>

                                            <div className="mt-1 flex">
                                                <i className="bx bxs-right-arrow hidden text-primary md:block"></i>
                                                <div className="md:-mt-1 md:pl-8">
                                                    <a
                                                        className="nav-underline inline-block pt-2 font-header text-xl font-bold uppercase text-primary"
                                                        href={entry.href}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {entry.name}
                                                    </a>
                                                    <div className="pt-2">
                                                        <span className="block font-body text-black">{entry.description}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Carrier;
